import React from 'react';
import Title from '../Title/Index';
import Container from '../Container/Index';
import ImageTag from '../ImageTag/Index';

const Residences = ({ Data }) => {
  if (!Data) return null;

  return (
    <Container _parentClass={'p-100 flex flex-wrap'}>
      <div className='w-full lg:w-[1000px] m-auto'>
        <Title
          firstHeading={Data.heading}
          secondHeading={Data.title}
          subTitle={Data.descp}
          _secondHeading={'mb-sm-3 mb-1'}
        />
      </div>
      <div className='w-full flex flex-wrap gap-5 md:gap-10  m-auto flex-center'>
        <div
          className='w-full lg:w-1/4 featureSlide'
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <ImageTag ImagePath={Data.creativeImage} ImageClass={'float-end'} />
        </div>

        <div className='w-full lg:w-1/3 flex flex-wrap'>
          <ul
            className='listItems'
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-duration="500"
            data-aos-once="true"
            data-aos-easing="ease-in-sine"
          >
            {Array.isArray(Data.info) && Data.info.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default Residences;